import React from 'react';

import { humanCase } from '@paragon/utilities';

import { StatusPercentage } from '../../selectors/getStatusPercentages';
import { statusColors } from '../statusColors';

interface StatusesAsColoredTextProps {
  readonly statusPercentages: readonly StatusPercentage[];
  readonly rowId: string;
}

export function StatusesAsColoredText(props: StatusesAsColoredTextProps) {
  const { statusPercentages, rowId } = props;
  return (
    <>
      {statusPercentages.map(({ status, percentage }, index) => (
        <span style={{ color: statusColors[status] }} key={`${rowId}-${status}`}>
          {`${statusPercentages.length > 1 ? `${percentage}% ` : ''}${humanCase(status)}${
            index === statusPercentages.length - 1 ? '' : ', '
          }`}
        </span>
      ))}
    </>
  );
}
